var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "restart-quiz-button",
      on: {
        click: function($event) {
          return _vm.$emit("click", $event)
        }
      }
    },
    [
      _c(
        "svg",
        {
          attrs: {
            width: "24px",
            height: "22px",
            viewBox: "0 0 24 22",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Quiz",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Results-Page",
                    transform: "translate(-335.000000, -778.000000)",
                    fill: "#FFFFFF",
                    "fill-rule": "nonzero"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M359,788.988522 C359.013367,794.553355 354.779638,799.248898 349.14431,799.919232 C343.508982,800.589566 338.252554,797.022897 336.90792,791.616417 C336.814195,791.171874 337.095509,790.734168 337.545014,790.625141 C337.994518,790.516114 338.45158,790.774728 338.580123,791.210825 C339.68538,795.618612 343.876518,798.599185 348.493857,798.261084 C353.111197,797.922984 356.804129,794.365106 357.229134,789.845268 C357.654139,785.32543 354.686898,781.165718 350.210412,780.005871 C345.733926,778.846025 341.057602,781.025306 339.149017,785.160752 L341.907291,784.205923 C342.124414,784.130624 342.363246,784.143636 342.57052,784.242057 C342.777794,784.340478 342.936269,784.516121 343.010601,784.729812 C343.164969,785.170794 342.92582,785.651016 342.476185,785.802939 L338.080186,787.323907 C337.988455,787.353512 337.8923,787.367794 337.795739,787.366156 C337.473059,787.366814 337.177027,787.190737 337.028594,786.909866 L335.106422,783.208843 C334.955268,782.939006 334.965771,782.609935 335.133839,782.34989 C335.301907,782.089845 335.600942,781.939978 335.914391,781.958704 C336.227841,781.977429 336.506099,782.161782 336.640712,782.43991 L337.597488,784.358019 C339.812527,779.683635 345.044924,777.147536 350.178663,778.260031 C355.312401,779.372526 358.966764,783.834409 358.96549,788.988522 L359,788.988522 Z",
                      id: "Path"
                    }
                  })
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cf81da0", { render: render, staticRenderFns: staticRenderFns })
  }
}